export default __webpack_public_path__ + "locales/de/WebPlugins.json?hash=c2d7b4457088229eb41826661b73f741";